import React from 'react';
import {withTranslation} from "react-i18next";
import {findSponsoredDayEntity, findSponsoredMonthEntity} from '../calendar/calendar-context';

const sponsoredDay = (props) => {
  let selectedDayEntity = findSponsoredDayEntity(props.date);
  let selectedMonthEntity = findSponsoredMonthEntity(props.date);

  let content = [];

  if (Object.keys(selectedDayEntity).length === 0 && Object.keys(selectedMonthEntity).length === 0) {
    content = <span className='no-sponsorship' dangerouslySetInnerHTML={{ __html: window.calendarParagraphLegendSponsorship }}></span>
    return <div className='sponsorship-text'>{content}</div>;
  }

  if (Object.keys(selectedDayEntity).length > 0) {
    if (props.i18n.language === 'en') {
      content.push(<span>We would like to thank <span className='text-unikatum-orange'>{selectedDayEntity.fieldPate}</span> for sponsoring today's day!</span>);
    } else {
      content.push(<span>Wir bedanken uns bei <span className='text-unikatum-orange'>{selectedDayEntity.fieldPate}</span> für die Kalenderpatenschaft des heutigen Tages!</span>);
    }
  }

  if (Object.keys(selectedMonthEntity).length > 0) {
    if (content.length > 0) {
      content.push(<span>&nbsp;</span>);
    }

    if (props.i18n.language === 'en') {
      content.push(<span>Calendar sponsor of the month is <span className='text-unikatum-orange'>{selectedMonthEntity.fieldPate}</span>, thank you very much!</span>);
    } else {
      content.push(<span>Die Monatspatenschaft hat <span className='text-unikatum-orange'>{selectedMonthEntity.fieldPate}</span> übernommen, vielen Dank!</span>);
    }
  }

  return <div className='sponsorship-text'>{content}</div>;
}

export default withTranslation()(sponsoredDay)
